<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col md:w-1/2 w-full">
        <h2>{{ $t("fidelization.Coupons") }}</h2>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="text-right">
          <router-link :to="{ name: 'new-coupon' }">
            <vs-button color="primary" type="border">{{
              $t("fidelization.CreateCoupon")
            }}</vs-button>
          </router-link>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <table-data-grid
          :data="itemsDataGrid"
          :dataColumns="dataColumns"
          link="coupon"
        >
          <template v-slot:actions="slotProps">
            <div class="dropdown-button-container">
              <vs-button
                class="btnx"
                type="filled"
                color="primary"
                @click="seeCoupon(slotProps.item.id)"
              >
                {{ $t("Ver") }}
              </vs-button>

              <vs-dropdown vs-trigger-click>
                <vs-button
                  class="btn-drop"
                  type="filled"
                  icon="expand_more"
                ></vs-button>
                <vs-dropdown-menu>
                  <ul style="min-width: 12rem">
                    <vs-divider class="m-1" />
                    <li>
                      <router-link
                        :to="slotProps.item.linkEdit"
                        class="cursor-pointer py-3 px-4 block hover:bg-primary hover:text-white w-full"
                      >
                        <feather-icon icon="EditIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">{{ $t("Editar") }}</span>
                      </router-link>
                    </li>
                    <vs-divider class="m-1" />
                    <li>
                      <span
                        @click="
                          deleteModalCoupon(
                            slotProps.item.id,
                            slotProps.item.name
                          )
                        "
                        class="cursor-pointer py-3 px-4 block hover:bg-danger text-danger hover:text-white w-full"
                      >
                        <feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">{{ $t("Eliminar") }}</span>
                      </span>
                    </li>
                  </ul>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </template>
        </table-data-grid>
        <vs-popup
          :title="$t('fidelization.SeeCoupon')"
          v-if="openModal"
          :active.sync="popupSeeCoupon"
        >
          <see-coupon :coupon="coupon" v-if="openModal" />
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import TableDataGrid from "../components/TableDataGrid";
import GenerateQr from "../components/GenerateQr";
import SeeCoupon from "@/components/coupons/SeeCoupon";
import CouponEdit from "@/views/CouponEdit";
import { mapActions, mapGetters } from "vuex";
import { formatDate } from "devextreme/localization";

export default {
  components: {
    TableDataGrid,
    GenerateQr,
    CouponEdit,
    SeeCoupon,
  },
  data() {
    return {
      dialog: false,
      dataColumns: [
        { caption: "ID", visible: false },
        {
          dataField: "name",
          caption: this.$t("Nombre"),
          visible: true,
          width: 100,
        },
        {
          dataField: "description",
          caption: this.$t("Especificaciones"),
          visible: true,
          width: 250,
        },
        {
          dataField: "Name_dish_group",
          caption: this.$t("fidelization.Category"),
          visible: true,
          width: 100,
        },
        {
          dataField: "amount",
          caption: this.$t("fidelization.Limit"),
          visible: true,
          width: 100,
        },
        {
          dataField: "starting_at",
          caption: this.$t("fidelization.From"),
          visible: true,
          width: 100,
        },
        {
          dataField: "finishing_at",
          caption: this.$t("fidelization.To"),
          visible: true,
          width: 100,
        },
        {
          dataField: "free_product_name_product",
          caption: this.$t("fidelization.FreeProduct"),
          visible: true,
          width: 100,
        },
        {
          dataField: "free_id_product",
          caption: this.$t("fidelization.FreeProduct"),
          visible: false,
        },
        { caption: "linkEdit", visible: false },
        { caption: "Slug", dataType: "text", visible: false },

        { visible: false },
      ],
    };
  },
  created() {
    this.refreshCoupons({ language: this.language });
  },
  computed: {
    ...mapGetters({
      languages: "getLanguages",
      itemsCoupons: "getCoupons",
      language: "getCurrentLanguage",
      coupon: "getCoupon",
    }),

    popupSeeCoupon: {
      get() {
        return this.$store.getters.getpopupSeeCoupon;
      },
      set(val) {
        this.$store.commit("setpopupSeeCoupon", val);
      },
    },
    openModal() {
      if (this.popupSeeCoupon === true && Object.keys(this.coupon).length > 0) {
        return true;
      }
      return false;
    },

    formatHour(hourToParse) {
      const aux = hourToParse.split("");
      return aux[0];
    },

    itemsDataGrid() {
      const items = this.itemsCoupons;

      const results = [];
      const aux = this;

      items.forEach(function (item, index) {
        const langs = new Array();
        const auxLangs = eval(items[index].available_languages);

        if (auxLangs) {
          auxLangs.forEach(function (ln) {
            langs.push(aux.languages[ln]);
          });
        }

        results[index] = {
          id: items[index].id,
          name: items[index].name,
          description: items[index].description,
          Name_dish_group: items[index].Name_dish_group,
          amount: items[index].amount,
          starting_at: items[index].starting_at,
          finishing_at: items[index].finishing_at,
          free_product_name: items[index].free_product_name,
          free_product_id: items[index].free_product_id,
          languages: langs.join(", "),
          linkEdit: `edit-coupon/${items[index].id}`,
        };
      }, items);

      return results;
    },
  },
  methods: {
    ...mapActions({
      refreshCoupons: "refreshCoupons",
      deleteCoupon: "deleteCoupon",
      getCoupon: "getCoupon",
    }),

    seeCoupon(id) {
      this.getCoupon({ id: id, language: this.language });
      this.popupSeeCoupon = true;
    },

    deleteModalCoupon(id, name) {
      const aux = this;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("fidelization.RemoveCouponTitle"),
        text: this.$t("fidelization.RemoveCouponConfirm", { nombre: name }),
        acceptText: this.$t("Aceptar"),
        cancelText: this.$t("Cancelar"),
        accept() {
          aux.deleteCoupon(id);
        },
      });
    },
  },
};
</script>

<style></style>
